import { computed, type ComputedRef } from 'vue';
import { store } from '@/plugins/store';
import type { Section } from '@/types';

// A Section-id -> Section lookup built once per change to the store's Section list, instead of a
// linear `find()` repeated per group - Index.vue's search filter and BarnSection's by-section view
// both resolve one group's Section on every row, which is O(groups x sections) per pass with `find()`
// and O(groups + sections) with this.
export function useSectionById(): ComputedRef<Map<number, Section>> {
    return computed(() => {
        const map = new Map<number, Section>();
        for (const section of store.state.sections ?? []) {
            map.set(section.id, section);
        }
        return map;
    });
}
